var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetPasswordPlaceholderImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 85,
    cy: 85,
    r: 85,
    transform: "translate(103 146)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(-103 -146)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 85,
    cy: 85,
    r: 85,
    transform: "translate(103 146)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(72.007 145.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(176.288 100.533)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M897.11,619.1s-16.5-2.142-4.194,24.56c0,0,11.213-4.8,11.659-15.643a8.624,8.624,0,0,0-7.232-8.883Z",
    transform: "translate(-888.357 -598.49)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M914.484,619.06s3.735,14.889-4.424,24.6",
    transform: "translate(-905.488 -598.494)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M909,601.994s5.94-14.64,17.033-20.071A23.941,23.941,0,0,0,936.9,571.37a40.255,40.255,0,0,0,2.724-6.84",
    transform: "translate(-904.652 -555.451)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1060.731,527.047c-1.156,1.453-7.141,3.581-7.141,3.581s.72-6.319,1.877-7.762a3.37,3.37,0,1,1,5.266,4.188Z",
    transform: "translate(-1018.784 -521.428)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1048,577.913c-1.761.592-7.937-.88-7.937-.88s4.034-4.9,5.795-5.5a3.37,3.37,0,1,1,2.142,6.376Z",
    transform: "translate(-1008.104 -560.782)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1000.868,642.514c-1.818-.377-6.408-4.767-6.408-4.767s5.957-2.2,7.777-1.82a3.37,3.37,0,0,1-1.369,6.585Z",
    transform: "translate(-972.11 -611.774)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M947.192,682.04c-1.856-.065-7.122-3.615-7.122-3.615s5.5-3.177,7.358-3.109a3.37,3.37,0,0,1-.236,6.722Z",
    transform: "translate(-929.177 -642.899)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1012.524,563.942c.238,1.843,4.259,6.756,4.259,6.756s2.648-5.772,2.412-7.615a3.37,3.37,0,1,0-6.671.859Z",
    transform: "translate(-986.319 -551.815)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M952.176,607.8c.777,1.685,6.086,5.171,6.086,5.171s.8-6.3.023-7.986a3.37,3.37,0,1,0-6.109,2.816Z",
    transform: "translate(-938.411 -585.682)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M901.945,663.677c.48,1.795,5.125,6.126,5.125,6.126s1.854-6.073,1.371-7.868a3.37,3.37,0,1,0-6.5,1.742Z",
    transform: "translate(-898.941 -630.195)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1060.731,527.047c-1.156,1.453-7.141,3.581-7.141,3.581s.72-6.319,1.877-7.762a3.37,3.37,0,1,1,5.266,4.188Z",
    transform: "translate(-1018.784 -521.428)",
    fill: "#fffffb",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1048,577.913c-1.761.592-7.937-.88-7.937-.88s4.034-4.9,5.795-5.5a3.37,3.37,0,1,1,2.142,6.376Z",
    transform: "translate(-1008.104 -560.782)",
    fill: "#fffffb",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1000.868,642.514c-1.818-.377-6.408-4.767-6.408-4.767s5.957-2.2,7.777-1.82a3.37,3.37,0,0,1-1.369,6.585Z",
    transform: "translate(-972.11 -611.774)",
    fill: "#fffffb",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M947.192,682.04c-1.856-.065-7.122-3.615-7.122-3.615s5.5-3.177,7.358-3.109a3.37,3.37,0,0,1-.236,6.722Z",
    transform: "translate(-929.177 -642.899)",
    fill: "#fffffb",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1012.524,563.942c.238,1.843,4.259,6.756,4.259,6.756s2.648-5.772,2.412-7.615a3.37,3.37,0,1,0-6.671.859Z",
    transform: "translate(-986.319 -551.815)",
    fill: "#fffffb",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M952.176,607.8c.777,1.685,6.086,5.171,6.086,5.171s.8-6.3.023-7.986a3.37,3.37,0,1,0-6.109,2.816Z",
    transform: "translate(-938.411 -585.682)",
    fill: "#fffffb",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M901.945,663.677c.48,1.795,5.125,6.126,5.125,6.126s1.854-6.073,1.371-7.868a3.37,3.37,0,1,0-6.5,1.742Z",
    transform: "translate(-898.941 -630.195)",
    fill: "#fffffb",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M946.56,633.606s5.94-14.64,17.033-20.071a23.94,23.94,0,0,0,10.865-10.556,40.258,40.258,0,0,0,2.724-6.84",
    transform: "translate(-934.3 -580.402)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1098.241,559.849c-1.156,1.453-7.141,3.581-7.141,3.581s.72-6.319,1.877-7.762a3.37,3.37,0,0,1,5.266,4.188Z",
    transform: "translate(-1048.392 -547.574)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1085.527,610.032c-1.761.592-7.937-.881-7.937-.881s4.034-4.9,5.795-5.5a3.37,3.37,0,0,1,2.142,6.376Z",
    transform: "translate(-1037.728 -586.245)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1038.4,674.154c-1.818-.377-6.408-4.767-6.408-4.767s5.957-2.2,7.777-1.82a3.37,3.37,0,0,1-1.369,6.585Z",
    transform: "translate(-1001.734 -636.749)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M984.712,713.638c-1.856-.065-7.122-3.615-7.122-3.615s5.5-3.172,7.358-3.107a3.37,3.37,0,0,1-.236,6.722Z",
    transform: "translate(-958.793 -667.843)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1050.044,595.582c.238,1.843,4.259,6.755,4.259,6.755s2.648-5.772,2.412-7.615a3.37,3.37,0,1,0-6.671.859Z",
    transform: "translate(-1015.935 -576.79)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M990.384,640.838c.777,1.685,6.086,5.171,6.086,5.171s.8-6.3.023-7.986a3.37,3.37,0,0,0-6.109,2.816Z",
    transform: "translate(-968.714 -612.069)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M939.907,696.913c.48,1.795,5.125,6.126,5.125,6.126s1.854-6.073,1.371-7.868a3.37,3.37,0,0,0-6.5,1.742Z",
    transform: "translate(-928.997 -656.769)",
    fill: "#08c4bb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M63.3,474.07c3.657,15.63,11.4,29.141,23.633,35.69,25.425,13.61,82.766,6.591,125.561-1.475a98,98,0,0,0,55.723-31.85Z",
    transform: "translate(-60.809 -383.513)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M309.864,61.086H286.383a2.03,2.03,0,1,1,0-4.059h4.059a2.03,2.03,0,1,1,0-4.059h-2.9a2.03,2.03,0,1,1,0-4.059H299.8a32.43,32.43,0,0,0-9.559-2.635c-33.417-4.293-45.348-1.453-49.557,1.475a46.8,46.8,0,0,1-17.176,7.529c-20.62,4.249-59.18,9.368-94.128-1.643C112.008,48.156,99.1,57.408,91.36,72.861H313.94a36.267,36.267,0,0,0-2.757-12.268A2.018,2.018,0,0,1,309.864,61.086Z",
    transform: "translate(-82.958 -44.1)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M51.948,319.2a103.441,103.441,0,0,0,.912,27.271l206.158,7.539a96.9,96.9,0,0,0,14.324-21.844Zm81.538,19.453h-4.059a2.03,2.03,0,0,1,0,4.059H105.946a2.03,2.03,0,1,1,0-4.059H110a2.03,2.03,0,1,1,0-4.059h-2.9a2.03,2.03,0,0,1,0-4.059h23.481a2.03,2.03,0,0,1,0,4.059h2.9a2.03,2.03,0,1,1,0,4.059Z",
    transform: "translate(-51.45 -261.266)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M284.46,181.38,59.384,186.857A89.927,89.927,0,0,0,54,210.1H280.517a96.152,96.152,0,0,0,3.271-14.815A70.2,70.2,0,0,0,284.46,181.38ZM99.694,199.321H95.635a2.03,2.03,0,1,1,0,4.059H72.154a2.03,2.03,0,1,1,0-4.059h4.059a2.03,2.03,0,0,1,0-4.059h-2.9a2.03,2.03,0,1,1,0-4.059H96.8a2.03,2.03,0,0,1,0,4.059h2.9a2.03,2.03,0,1,1,0,4.059Z",
    transform: "translate(-53.468 -152.478)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M363.4,233.81s-9.386-51.483-27.285-59.837a252.966,252.966,0,0,0-36.232-13.155,20.138,20.138,0,0,0-2.4-3.137c-6.374-6.654-10.2-6.53-10.823-6.448a32.414,32.414,0,0,1-.632-4c-.019-.211-.038-.407-.055-.615l.055-.027q-.057-.6-.1-1.232a31.723,31.723,0,0,0,7.118-5.184c.027.091.051.181.08.274q6.89-5.824,13.5-11.965a9.278,9.278,0,0,0,3.021-4.131,6.063,6.063,0,0,0,.158-1.753c.057-1.264-.242-2.555-.293-3.836a4.392,4.392,0,0,1,.051-.607c.295-2.1,1.753-3.817,2.949-5.576a26.293,26.293,0,0,0,4.472-15.053,25.488,25.488,0,0,0-1.053-7.583c-.933-3.122-2.875-6.4-6.109-7.084a26.9,26.9,0,0,0-3.827-.181c-5.285-.337-9.241-4.634-13.456-7.783a35.518,35.518,0,0,0-17.606-6.833,14.107,14.107,0,0,0-5.94.407c-4.253,1.416-6.836,5.787-10.933,7.583-3.029,1.336-6.53,1.119-9.69,2.121-4.7,1.5-8.7,6.319-8.8,11.276v.642c-.053,2.5.843,5.056.914,7.619q0,.348.011.7a22.93,22.93,0,0,1-1.363,8.146,11.022,11.022,0,0,0-1.129,4.424,2.961,2.961,0,0,0,.7,2.317l1.017-.9A30.766,30.766,0,0,0,250.3,141.642q.059.946.114,2.026c.16,3.122.286,7.038.251,11.306l-9.934,9.132-25.539,11.586s-23.357,4.933-18.326,37.746l2.4,20.374h21.324l-.048.107h31.65l.019-.107h75.3l-.015.107h2.949v-.107Zm-76.556-82.054a21.889,21.889,0,0,1,1.517,4.171,17.088,17.088,0,0,1-1.637-4.4l.032.057Zm-36.194,4.213q0,.6-.021,1.215l-.051.072a10.32,10.32,0,0,1,.072-1.3Z",
    transform: "translate(-165.675 -62.926)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M480,364.641l-4.213,40.234-22.539,7.162s-29.28-5.477-21.7-21.276c5.395-11.238,5.245-31.321,4.71-41.98-.211-4.327-.5-7.1-.5-7.1s38.338-33.493,35.178-3.37a71.284,71.284,0,0,0-.308,13.958C472.055,367.105,480,364.641,480,364.641Z",
    transform: "translate(-350.498 -266.431)",
    fill: "#fdc2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M480,364.641l-4.213,40.234-22.539,7.162s-29.28-5.477-21.7-21.276c5.395-11.238,5.245-31.321,4.71-41.98-.211-4.327-.5-7.1-.5-7.1s38.338-33.493,35.178-3.37a71.284,71.284,0,0,0-.308,13.958C472.055,367.105,480,364.641,480,364.641Z",
    transform: "translate(-350.498 -266.431)",
    fill: "#fffffb",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M491.428,335.31a71.284,71.284,0,0,0-.308,13.958,30.559,30.559,0,0,1-34.374-3.486c-.211-4.327-.5-7.1-.5-7.1S494.588,305.187,491.428,335.31Z",
    transform: "translate(-370.985 -264.063)",
    fill: "#fffffb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 30.544,
    cy: 30.544,
    r: 30.544,
    transform: "translate(74.943 26.591)",
    fill: "#fdc2cc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 30.544,
    cy: 30.544,
    r: 30.544,
    transform: "translate(74.943 26.591)",
    fill: "#fffffb",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M371.418,551.555H213.01l-2.317-20.012c-4.845-32.229,17.694-37.074,17.694-37.074l24.646-11.375,9.8-9.163c-3.16,12.007,20.749,36.969,20.749,36.969h0a5.661,5.661,0,0,0,.436-.453c.645-.7,2.184-2.465,5.791-6.833,1.289-1.565,2.846-3.463,4.721-5.768,9.016-11.08,4.39-24.172,3.008-26.879l-.086-.169c-.053-.1-.093-.175-.124-.23a.343.343,0,0,0-.032-.057.334.334,0,0,1-.023-.042l11.586,9.058s.444.118,1.264.35A239.43,239.43,0,0,1,345.084,492.8C362.36,501,371.418,551.555,371.418,551.555Z",
    transform: "translate(-176.615 -380.671)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M579.761,503.2c-1.9-1.9-14.745-4.213-14.745-4.213.421,5.056-15.167,12.85-15.167,12.85l1.159,39.6h-7.474l-1.264-35.6,3.581-5.056h0l.436-.453a69.526,69.526,0,0,0,5.791-6.833c1.289-1.565,2.846-3.463,4.721-5.768,9.016-11.08,4.39-24.172,3.008-26.879l-.086-.168c-.051-.1-.091-.175-.124-.23a.343.343,0,0,0-.032-.057.33.33,0,0,1-.023-.042h0s3.792-.843,10.532,6.319a19.739,19.739,0,0,1,2.317,3.088C577.868,488.551,581.432,504.872,579.761,503.2Z",
    transform: "translate(-438.885 -380.557)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M579.761,503.2c-1.9-1.9-14.745-4.213-14.745-4.213.421,5.056-15.167,12.85-15.167,12.85l1.159,39.6h-7.474l-1.264-35.6,3.581-5.056h0l.436-.453a69.526,69.526,0,0,0,5.791-6.833c1.289-1.565,2.846-3.463,4.721-5.768,9.016-11.08,4.39-24.172,3.008-26.879l-.086-.168c-.051-.1-.091-.175-.124-.23a.343.343,0,0,0-.032-.057.33.33,0,0,1-.023-.042h0s3.792-.843,10.532,6.319a19.739,19.739,0,0,1,2.317,3.088C577.868,488.551,581.432,504.872,579.761,503.2Z",
    transform: "translate(-438.885 -380.557)",
    fill: "#fffffb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M313.25,703.4s9.9,20.222,10.427,32.124",
    transform: "translate(-258.108 -564.535)",
    fill: "#fffffb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M763.144,714.31,760.3,734.848h2.844Z",
    transform: "translate(-600.149 -563.857)",
    fill: "#fffffb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M323.75,519.115l15.693-35.7s4.424-8.426,5.477-16.852,6.741-21.7,6.741-21.7,14.113-17.905,20.644-15.377-5.687,12.007-5.687,12.007,17.905,6.951,5.688,27.595-12.428,16.852-12.428,16.852l-6,33.177Z",
    transform: "translate(-266.396 -348.126)",
    fill: "#fffffb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M321.75,519.1l15.693-35.7s4.424-8.426,5.477-16.852c.67-5.357,3.212-12.673,4.975-17.292a26.512,26.512,0,0,1,5-8.215c4.563-5.106,12.85-13.34,17.412-11.571,6.53,2.528-5.687,12.007-5.687,12.007s17.905,6.951,5.688,27.595-12.428,16.852-12.428,16.852l-6,33.177Z",
    transform: "translate(-264.817 -348.109)",
    fill: "#feb7c3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 0.632,
    cy: 0.632,
    r: 0.632,
    transform: "translate(114.229 39.336)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 0.632,
    cy: 0.632,
    r: 0.632,
    transform: "translate(111.28 40.6)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M411.684,94.972c3.048-.986,6.431-.773,9.355-2.083,3.954-1.774,6.446-6.067,10.549-7.457a13.546,13.546,0,0,1,5.732-.4,33.929,33.929,0,0,1,16.991,6.713c4.068,3.094,7.885,7.314,12.984,7.644a25.336,25.336,0,0,1,3.693.177c3.126.67,5,3.891,5.9,6.951a26.175,26.175,0,0,1-3.3,21.613c-1.154,1.727-2.561,3.419-2.846,5.477-.278,2.018.581,4.11.08,6.086a9.075,9.075,0,0,1-2.915,4.057q-6.372,6.027-13.024,11.744c-2.3-7.322,1.076-15.207.55-22.864-.211-2.983-1.264-6.239-3.895-7.647-2.462-1.314-5.61-.632-8.1-1.9-2.781-1.4-3.922-4.719-6.025-7.015-3.581-3.918-9.8-4.424-14.8-2.654s-9.1,5.409-13.06,8.959l-7.2,6.456c-1.405-1.584-.339-4.015.421-6a24.367,24.367,0,0,0,1.306-9.319c-.061-2.528-.933-5.024-.883-7.484C403.294,101.184,407.144,96.441,411.684,94.972Z",
    transform: "translate(-327.895 -76.329)",
    fill: "#fffffb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M411.684,91.972c3.048-.986,6.431-.773,9.355-2.083,3.954-1.774,6.446-6.067,10.549-7.457a13.547,13.547,0,0,1,5.732-.4,33.929,33.929,0,0,1,16.991,6.713c4.068,3.094,7.885,7.314,12.984,7.644a25.336,25.336,0,0,1,3.693.177c3.126.67,5,3.891,5.9,6.951a26.175,26.175,0,0,1-3.3,21.613c-1.154,1.727-2.561,3.419-2.846,5.477-.278,2.018.581,4.11.08,6.086a9.075,9.075,0,0,1-2.915,4.057q-6.372,6.027-13.024,11.744c-2.3-7.322,1.076-15.207.55-22.864-.211-2.983-1.264-6.239-3.895-7.647-2.462-1.314-5.61-.632-8.1-1.9-2.781-1.4-3.922-4.719-6.025-7.015-3.581-3.918-9.8-4.424-14.8-2.654s-9.1,5.409-13.06,8.959l-7.2,6.456c-1.405-1.584-.339-4.015.421-6a24.367,24.367,0,0,0,1.306-9.319c-.061-2.528-.933-5.024-.883-7.484C403.294,98.184,407.144,93.441,411.684,91.972Z",
    transform: "translate(-327.895 -73.961)",
    fill: "#865a61"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPasswordPlaceholderImage);
export default __webpack_public_path__ + "static/media/reset-password-placeholder-image.8b6fcdf9b5bc320b6765bff385dd1de1.svg";
export { ForwardRef as ReactComponent };